import { type NavigationState, type SetSwitchProps, type DispatchProps, type SetSwitchesProps } from 'src/types'

import { defaultNavigation } from './defaults'

const setSwitch = (state: NavigationState, { switchID, boolean }: SetSwitchProps) => ({
  ...state,
  [switchID]: boolean
})

const setSwitches = (state: NavigationState, { booleans }: SetSwitchesProps) => {
  const newState = {...state}

  booleans.forEach((bool) => {
    const key = Object.keys(bool)[0]
    newState[key] = bool[key]
  })

  return newState
}

// consider adding props that last from game to game
const reset = () => defaultNavigation

export const reducer = (state: NavigationState, action: DispatchProps) => {
  switch (action.type) {
    case 'RESET':
      return reset()
    case 'SET_SWITCH':
      return setSwitch(state, action)
    case 'SET_BOOLEANS':
      return setSwitches(state, action)
    default:
      return state
  }
}
